import { render, staticRenderFns } from "./YourPlanContent.vue?vue&type=template&id=10c4a783&scoped=true&lang=pug&"
import script from "./YourPlanContent.vue?vue&type=script&lang=js&"
export * from "./YourPlanContent.vue?vue&type=script&lang=js&"
import style0 from "./YourPlanContent.vue?vue&type=style&index=0&id=10c4a783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c4a783",
  null
  
)

export default component.exports